import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
export const RulePinOutOfStockOffIcon = (props) => (<SvgIcon viewBox="0 0 16 16" {...props}>
    <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth="0.911458"/>
    <path d="M11.6812 3.88086L3.88125 12.2148" fill="none" stroke="currentColor" strokeWidth="0.911458" strokeLinecap="round"/>
  </SvgIcon>);
export default RulePinOutOfStockOffIcon;
